<template>
    <main>
        <div class="forum-2025-mobile">
            <!-- Banner区域 -->
            <div class="banner-section">
                <div class="banner-image">
                    <img src="@/assets/image/2025/anonymous/banner-wap.png" alt="2026戴尔科技峰会" />
                </div>
            </div>

            <!-- 描述区域 -->
            <div class="description-section">
                <div class="content">
                    <p>
                        2026戴尔科技峰会将全国线上线下企业"核心困局 vs. 破局路径"进行深入探讨，戴尔科技会携手"破局者"们以全球智慧+本地敏捷，用全球验证的技术组合驱动供应链、数据、全球化等多重困局，赋能企业的韧性增长。同时，我们还将与生态伙伴共同展示更多不同行业AI场景深化与商业支撑案例，希望能够激发"破局者"们的创新灵感，找到那个最适合您企业的"破局关键点"。
                    </p>
                </div>
            </div>

            <!-- 论坛区域 -->
            <div class="forums-section">
                <!-- 主论坛图片 -->
                <div class="main-forum-row">
                    <div class="main-forum-image" @click="openMainForum">
                        <img src="@/assets/image/2025/anonymous/main-img-wap.png" alt="破局者·智行合璧" />
                    </div>
                </div>

                <!-- 分论坛图片 -->
                <div class="sub-forums-row">
                    <div class="sub-forum-image" @click="openSubForum('office')">
                        <img src="@/assets/image/2025/anonymous/sub-img-1-wap.png" alt="打造智能现代化办公空间" />
                    </div>

                    <div class="sub-forum-image" @click="openSubForum('infrastructure')">
                        <img src="@/assets/image/2025/anonymous/sub-img-2-wap.png" alt="基础设施现代化与出海" />
                    </div>

                    <div class="sub-forum-image" @click="openSubForum('datacenter')">
                        <img src="@/assets/image/2025/anonymous/sub-img-3-wap.png" alt="智算数据中心及网络韧性" />
                    </div>

                    <div class="sub-forum-image" @click="openSubForum('partnership')">
                        <img src="@/assets/image/2025/anonymous/sub-img-4-wap.png" alt="合作伙伴峰会" />
                    </div>
                </div>

                <!-- 了解更多大会相关信息 -->
                <div class="main-forum-row more-info-section">
                    <div class="main-forum-image" @click="goToHome">
                        <img src="@/assets/image/2025/anonymous/main-img-wap-1.png" alt="了解更多大会相关信息" />
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'Forum2025Mobile',
    data() {
        return {
            // 页面数据
        }
    },
    methods: {
        // 跳转到首页
        goToHome() {
            this.$router.push('/');
        },
        
        // 打开主论坛
        openMainForum() {
            window.open('https://www.dellemc-solution.com/webinar-dtf/?channelId=6227216&mainId=6227216&isnm=1#/', '_blank');
        },
        
        // 打开分论坛
        openSubForum(type) {
            let url = '';
            switch(type) {
                case 'office':
                    url = 'https://www.dellemc-solution.com/webinar-dtf/?channelId=6237195&mainId=6227216&isnm=1#/';
                    break;
                case 'infrastructure':
                    url = 'https://www.dellemc-solution.com/webinar-dtf/?channelId=6237286&mainId=6227216&isnm=1#/';
                    break;
                case 'datacenter':
                    url = 'https://www.dellemc-solution.com/webinar-dtf/?channelId=6237263&mainId=6227216&isnm=1#/';
                    break;
                case 'partnership':
                    url = 'https://www.dellemc-solution.com/webinar-dtf/?channelId=6227229&mainId=6227229&isnm=1#/';
                    break;
            }
            if(url) {
                window.open(url, '_blank');
            }
        }
    },
    mounted() {
        // 页面加载完成后的操作
    }
}
</script>

<style scoped>
.forum-2025-mobile {
    min-height: 100vh;
    background: #f5f5f5;
}

/* Banner区域 */
.banner-section {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.banner-image {
    position: relative;
    width: 100%;
}

.banner-image img {
    width: 100%;
    height: auto;
    display: block;
}



/* 描述区域 */
.description-section {
    padding: 20px;
    background: #F6F6F6;
}

.description-section .content {
    text-align: left;
}

.description-section .content p {
    font-size: 16px;
    line-height: 1.6;
    color: #000;
    margin: 0;
}

/* 论坛区域 */
.forums-section {
    padding: 20px;
    background: #F6F6F6;
}

/* 主论坛行 */
.main-forum-row {
    margin-bottom: 15px;
}

/* 了解更多信息区域 */
.more-info-section {
    margin-top: 15px;
}

.main-forum-image {
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.main-forum-image:active {
    transform: scale(0.98);
}

.main-forum-image img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.3s ease;
}

.main-forum-image:active img {
    transform: scale(1.02);
}

/* 分论坛行 */
.sub-forums-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
}

.sub-forum-image {
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.sub-forum-image:active {
    transform: scale(0.98);
}

.sub-forum-image img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.3s ease;
}

.sub-forum-image:active img {
    transform: scale(1.05);
}

/* 响应式调整 */
@media (max-width: 375px) {
    .forums-section {
        padding: 15px;
    }
    
    .sub-forums-row {
        gap: 10px;
    }
}
</style>